import { useTranslation } from "react-i18next";
import { Bell } from "lucide-react";
import { useLocation } from "wouter";
import { useCoachSignals } from "@/lib/intelligence/coach";

/**
 * Notification entry point. All notifications now live inside Coach AI (Plate
 * Talk), so the bell no longer opens its own dropdown — it routes straight to the
 * coach and keeps a needs-attention indicator derived from the same consolidated
 * intelligence feed the coach shows.
 */
export function NotificationBell() {
  const { t } = useTranslation();
  const [, setLocation] = useLocation();
  const { needsAttentionCount } = useCoachSignals();

  return (
    <button
      onClick={() => setLocation("/plate-talk")}
      data-testid="notification-bell"
      className="relative w-8 h-8 flex items-center justify-center rounded-lg text-muted-foreground hover:text-primary hover:bg-primary/10 transition-all duration-200"
      title={t("coach.talkToCoach")}
      aria-label={t("coach.talkToCoach")}
    >
      <Bell className="w-4 h-4" />
      {needsAttentionCount > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 flex items-center justify-center rounded-full bg-primary text-primary-foreground text-[10px] font-bold leading-none">
          {needsAttentionCount > 9 ? "9+" : needsAttentionCount}
        </span>
      )}
    </button>
  );
}
